(() => {
  if (window.videoControlsInit) return;
  window.videoControlsInit = true;

/*
 * ========================================
 * GLOBAL VIDEO CONTROL
 * ========================================
 */

// Only one controlled video can play at a time.
function pauseOtherVideos(currentVideo) {
  const videos = document.querySelectorAll(
    '.js-video-custom-play video, .js-gallery-video video'
  );

  videos.forEach((video) => {
    if (video !== currentVideo && !video.paused) {
      video.pause();
    }
  });
}


/*
 * ========================================
 * VIDEO SECTION
 * ========================================
 */

document.addEventListener('click', (event) => {
  const videoSection = event.target.closest('.js-video-custom-play');

  if (!videoSection) return;

  const video = videoSection.querySelector('video');
  const videoButton = event.target.closest('.js-video-control');
  const videoOverlay = event.target.closest('.video-section__overlay');

  // Video is already loaded.
  if (video) {
    if (event.target === video || videoButton || videoOverlay) {
      event.preventDefault();
      event.stopPropagation();

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }

      return;
    }
  }

  // Video is not loaded yet and custom overlay/button was clicked.
  if (videoButton || videoOverlay) {
    event.preventDefault();
    event.stopPropagation();

    const posterButton = videoSection.querySelector('.deferred-media__poster');

    if (!posterButton) return;

    posterButton.click();

    return;
  }

  // Initial Dawn poster click.
  const posterButton = event.target.closest('.deferred-media__poster');

  if (!posterButton) return;

  setTimeout(() => {
    const loadedVideo = videoSection.querySelector('video');

    if (!loadedVideo) return;

    loadedVideo.play();
  }, 0);
});


// Video section started
document.addEventListener(
  'play',
  (event) => {
    if (event.target.tagName !== 'VIDEO') return;

    const video = event.target;
    const videoSection = video.closest('.video-section');

    if (!videoSection?.classList.contains('js-video-custom-play')) return;

    // Stop any other controlled video.
    pauseOtherVideos(video);

    videoSection.classList.add('is-playing');
  },
  true
);


// Video section paused
document.addEventListener(
  'pause',
  (event) => {
    if (event.target.tagName !== 'VIDEO') return;

    const videoSection = event.target.closest('.video-section');

    if (!videoSection?.classList.contains('js-video-custom-play')) return;

    videoSection.classList.remove('is-playing');
  },
  true
);


// Video section ended
document.addEventListener(
  'ended',
  (event) => {
    if (event.target.tagName !== 'VIDEO') return;

    const video = event.target;
    const videoSection = video.closest('.video-section');

    if (!videoSection?.classList.contains('js-video-custom-play')) return;

    video.currentTime = 0;
    videoSection.classList.remove('is-playing');
  },
  true
);


/*
 * ========================================
 * PRODUCT GALLERY VIDEO
 * ========================================
 */

document.addEventListener('click', (event) => {
  const videoSlide = event.target.closest('.js-gallery-video');

  if (!videoSlide) return;

  const video = videoSlide.querySelector('video');
  const videoOverlay = event.target.closest('.js-gallery-video-overlay');

  if (!video) return;

  // Clicking the video or its overlay toggles play/pause.
  if (event.target === video || videoOverlay) {
    event.preventDefault();
    event.stopPropagation();

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }
});


// Gallery video started
document.addEventListener(
  'play',
  (event) => {
    if (event.target.tagName !== 'VIDEO') return;

    const video = event.target;
    const videoSlide = video.closest('.js-gallery-video');

    if (!videoSlide) return;

    // Stop any other controlled video.
    pauseOtherVideos(video);

    videoSlide.classList.add('is-playing');
  },
  true
);


// Gallery video paused
document.addEventListener(
  'pause',
  (event) => {
    if (event.target.tagName !== 'VIDEO') return;

    const videoSlide = event.target.closest('.js-gallery-video');

    if (!videoSlide) return;

    videoSlide.classList.remove('is-playing');
  },
  true
);


// Gallery video ended
document.addEventListener(
  'ended',
  (event) => {
    if (event.target.tagName !== 'VIDEO') return;

    const video = event.target;
    const videoSlide = video.closest('.js-gallery-video');

    if (!videoSlide) return;

    video.currentTime = 0;
    videoSlide.classList.remove('is-playing');
  },
  true
);

})();
